var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showLeft,
            expression: "showLeft",
          },
        ],
        staticClass: "left_tree",
      },
      [
        _c(
          "a-spin",
          {
            staticStyle: { height: "100%" },
            attrs: { spinning: _vm.treeSpin },
          },
          [
            _c(
              "div",
              [
                _c(
                  "a-radio-group",
                  {
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  },
                  [
                    _c("a-radio-button", { attrs: { value: "dept" } }, [
                      _vm._v(" 部门 "),
                    ]),
                    _c("a-radio-button", { attrs: { value: "customer" } }, [
                      _vm._v(" 员工 "),
                    ]),
                  ],
                  1
                ),
                _c(
                  "vxe-button",
                  {
                    staticStyle: { "margin-top": "12px" },
                    on: { click: _vm.closeAll },
                  },
                  [_vm._v("清空")]
                ),
              ],
              1
            ),
            _vm.type === "dept"
              ? _c(
                  "div",
                  { staticClass: "tree-box" },
                  [
                    _c(
                      "a-tree",
                      {
                        attrs: {
                          "show-icon": true,
                          checkable: "",
                          "expanded-keys": _vm.expandedKeys,
                          "auto-expand-parent": _vm.autoExpandParent,
                          "selected-keys": _vm.selectedKeys,
                          "tree-data": _vm.treeData,
                          selectable: false,
                          replaceFields: {
                            children: "children",
                            title: "deptName",
                            key: "deptId",
                          },
                        },
                        on: { expand: _vm.onExpand, check: _vm.onSelect },
                        model: {
                          value: _vm.checkedKeys,
                          callback: function ($$v) {
                            _vm.checkedKeys = $$v
                          },
                          expression: "checkedKeys",
                        },
                      },
                      [
                        _c("a-icon", {
                          staticStyle: { color: "#2fcfeb" },
                          attrs: { slot: "dealer", type: "team" },
                          slot: "dealer",
                        }),
                        _c("a-icon", {
                          staticStyle: { color: "#52c41a" },
                          attrs: { slot: "region", type: "cluster" },
                          slot: "region",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.type === "customer"
              ? _c(
                  "div",
                  { staticClass: "tree-box" },
                  [
                    _c("Tree", {
                      attrs: {
                        list: _vm.treeData,
                        selectedUser: _vm.selectedUser,
                        userName: "",
                        detph: 0,
                      },
                      on: { change: _vm.checkedUser },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "right_table", class: { showLeft: !_vm.showLeft } },
      [
        _vm.showLeft
          ? _c("a-icon", {
              staticClass: "close",
              attrs: { type: "left-circle" },
              on: {
                click: function ($event) {
                  _vm.showLeft = false
                },
              },
            })
          : _c("a-icon", {
              staticClass: "close",
              attrs: { type: "right-circle" },
              on: {
                click: function ($event) {
                  _vm.showLeft = true
                },
              },
            }),
        _c("x-grid", {
          ref: "grid",
          attrs: {
            id: "formList",
            rowId: _vm.rowId,
            "pager-config": _vm.pagerConfig,
            "form-config": _vm.formConfig,
            url: _vm.url,
            columns: _vm.columns,
            otherParams: {
              planMold: 3,
              receiveDeptId: _vm.receiveDeptId,
              userId: _vm.userId,
            },
            "checkbox-config": _vm.checkboxConfig,
            "toolbar-config": _vm.toolbarConfig,
            "print-config": _vm.printConfig,
            "export-config": _vm.exportConfig,
            cellClick: _vm.chooseRow,
            cellDbClick: _vm.updateRow,
          },
          on: { "toolbar-addData": _vm.addRow },
          scopedSlots: _vm._u(
            [
              {
                key: _vm.toolbarConfig.templatelSlots,
                fn: function () {
                  return [
                    _c("div", { staticClass: "status_box" }, [
                      _c(
                        "span",
                        {
                          staticClass: "status_item",
                          class: _vm.navSwitch == 0 ? "active" : "",
                          on: {
                            click: function ($event) {
                              return _vm.changeNav(0)
                            },
                          },
                        },
                        [_vm._v("厂家")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "status_item",
                          class: _vm.navSwitch == 1 ? "active" : "",
                          on: {
                            click: function ($event) {
                              return _vm.changeNav(1)
                            },
                          },
                        },
                        [_vm._v("经理部")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "status_item",
                          class: _vm.navSwitch == 2 ? "active" : "",
                          on: {
                            click: function ($event) {
                              return _vm.changeNav(2)
                            },
                          },
                        },
                        [_vm._v("经销商")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "status_item",
                          class: _vm.navSwitch == 3 ? "active" : "",
                          on: {
                            click: function ($event) {
                              return _vm.changeNav(3)
                            },
                          },
                        },
                        [_vm._v("销售顾问")]
                      ),
                      _c(
                        "div",
                        { staticClass: "btns_box" },
                        [
                          _vm.navSwitch == 0
                            ? _c("vxe-button", { on: { click: _vm.addRow } }, [
                                _vm._v("新增"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "operate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm.finish &&
                    row.provideTypeName == "未下发" &&
                    _vm.navSwitch == 0
                      ? _c(
                          "vxe-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    _vm.navSwitch != 3
                      ? _c(
                          "vxe-button",
                          {
                            attrs: { size: "mini", status: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.checkData(row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        )
                      : _vm._e(),
                    _vm.navSwitch != 3 && row.provideTypeName == "未下发"
                      ? _c(
                          "vxe-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.issuedPlan(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(row.planClassify === 1 ? "确认" : "下发")
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.finish && _vm.navSwitch == 0 && row.canDelete === 1
                      ? _c(
                          "a-popconfirm",
                          {
                            attrs: {
                              title: "确定删除吗？",
                              "ok-text": "确定",
                              "cancel-text": "取消",
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.deleteTableRow(row)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "icon",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return function (e) {
                                      return e.preventDefault()
                                    }.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c("vxe-button", { attrs: { size: "mini" } }, [
                                  _vm._v("删除"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ],
            null,
            true
          ),
        }),
        _c(
          "formModal",
          {
            attrs: {
              title: _vm.title,
              centered: "",
              closable: true,
              footer: null,
              maskClosable: false,
              visible: _vm.editModalVisible,
              width: 1200,
            },
          },
          [
            _vm.editModalVisible
              ? _c("detailForm", {
                  ref: "form",
                  attrs: {
                    rowId: _vm.editRowId,
                    index: _vm.index,
                    navFlag: _vm.navFlag,
                    strainIdId: _vm.strainIdId,
                    importFlag: _vm.importFlag,
                    disabledDetail: _vm.disabledDetail,
                    navSwitch: _vm.navSwitch,
                  },
                  on: {
                    cancelled: function ($event) {
                      return _vm.closeEdit()
                    },
                    saved: function ($event) {
                      return _vm.closeEdit(true)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "a-modal",
          {
            attrs: {
              title: "查看完成情况",
              centered: "",
              footer: null,
              maskClosable: true,
              width: 1200,
              closable: true,
            },
            model: {
              value: _vm.showTransferPop,
              callback: function ($$v) {
                _vm.showTransferPop = $$v
              },
              expression: "showTransferPop",
            },
          },
          [
            _vm.showTransferPop
              ? _c("finishResult", {
                  ref: "finishResult",
                  attrs: {
                    transferIdArr: _vm.transferIdArr,
                    planId: _vm.issuedId,
                    navSwitch: _vm.navSwitch,
                    deptOrUser: _vm.deptOrUser,
                  },
                  on: { close: _vm.closeTransferPop },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "a-modal",
          {
            attrs: {
              title: "查看完成情况",
              centered: "",
              footer: null,
              maskClosable: true,
              width: 1200,
              closable: true,
            },
            model: {
              value: _vm.dealerProp,
              callback: function ($$v) {
                _vm.dealerProp = $$v
              },
              expression: "dealerProp",
            },
          },
          [
            _vm.dealerProp
              ? _c("dealerFinishResult", {
                  ref: "finishResult",
                  attrs: {
                    transferIdArr: _vm.transferIdArr,
                    planId: _vm.issuedId,
                    deptOrUser: _vm.deptOrUser,
                    navSwitch: _vm.navSwitch,
                  },
                  on: { close: _vm.closeTransferPop },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "a-modal",
          {
            attrs: {
              title: "查看完成情况",
              centered: "",
              footer: null,
              maskClosable: true,
              width: 1200,
              closable: true,
            },
            model: {
              value: _vm.userProp,
              callback: function ($$v) {
                _vm.userProp = $$v
              },
              expression: "userProp",
            },
          },
          [
            _vm.userProp
              ? _c("userFinishResult", {
                  ref: "finishResult",
                  attrs: {
                    transferIdArr: _vm.transferIdArr,
                    planId: _vm.issuedId,
                    deptOrUser: _vm.deptOrUser,
                    navSwitch: _vm.navSwitch,
                  },
                  on: { close: _vm.closeTransferPop },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }